import Transition from './Transition.js'

export default class AppTransition {

  constructor({ canvas, video }) {
    this.canvas = canvas
    this.video = video
    this.experience = new Transition(this.canvas, this.video)
  }
  
  destroy() {
    this.experience.destroy()
    this.experience = null
  }

}